import React, { Component } from 'react';
import { isNotLoginOrExpired } from '../../helpers/Common';
import EventEmitter, { SHOW_GUEST_POPUP } from '../../helpers/EventEmitter';
import Item from './Item';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

class List extends Component {
  componentDidMount() {
    const { currentTab } = this.props;
    if (this.isLocked(currentTab - 1)) {
      const indexs = Object.values(I18n.t(this.props.listTab)).map(
        (_, index) => index,
      );
      const notLockIndex = indexs.find((_, index) => !this.isLocked(index));
      this.onTabClick(notLockIndex);
    }
  }

  onTabClick = index => {
    const { changeTab } = this.props;
    if (this.isLocked(index)) {
      EventEmitter.dispatch(SHOW_GUEST_POPUP);
      return;
    }

    changeTab(index + 1);
  };

  isLocked = index => {
    const { user, locks } = this.props;

    return isNotLoginOrExpired(user) && locks.includes(index + 1);
  };

  render() {
    const { user, locks, tooltips } = this.props;
    const tabs = Object.values(I18n.t(this.props.listTab)).map(value => {
      return { name: value };
    });

    let className =
      'tab-timer nav nav-tabs m-tabs-line m-tabs-line--success custom-tabs mt-2 mb-10';

    className =
      this.props.disableTabNormal === true
        ? className
        : ['tab-normal', className].join(' ');

    return (
      <ul className={className} role="tablist">
        {tabs.map((value, index) => {
          return (
            <Item
              tooltipMess={tooltips[index]}
              isLocked={isNotLoginOrExpired(user) && locks.includes(index + 1)}
              key={index}
              {...value}
              isActive={this.props.currentTab === index + 1}
              changeTab={() => this.onTabClick(index)}
            />
          );
        })}
      </ul>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
  user: state.userInfo,
});

List.defaultProps = {
  locks: [],
  tooltips: [],
};

export default connect(mapStateToProps)(List);
